import Form from '@/utils/form/index'
import { status } from './config/index'
import SendRecord from './components/index.vue'
import UploadSelect from '@/components/select/upload-select/upload-select.vue'
import { onSuccess, beforeRemove } from './config/fn'

const fileNoAttrs = {
  url: '/srmFile/uploadFile',
  baseURL: process.env.VUE_APP_BASE_DATA_API,
  getData: () => ({ fileType: 'inquiry' }),
  onSuccess,
  beforeRemove
}

export default new Form('data.data')
  .url('/srmData/addData', process.env.VUE_APP_BASE_DATA_API)
  .dataUrl('/srmData/getCurrentInfo', process.env.VUE_APP_BASE_DATA_API)
  .title('formTitle.baseInfo')
  .add('dataName').required()
  .add('dataNo').required()
  .add('fileType').op('fileType').required()
  .add('status').op(status).required()
  .add('fileVersion').required()
  .lib('remarks')
  .add('fileList').component(UploadSelect).col(24).attrs(fileNoAttrs).required()
  .addGroup('settingTitle')
  .add('sendRecordList').component(SendRecord).label().bindFormItem('labelWidth', '0').col(24)
  .addGroup('formTitle.othersInfo')
  .add('addUserName').disabled()
  .add('addDeptName').disabled()
  .add('addUserPhone')
  .end()

